import Container from '@/components/Container';
import { Typography } from '@mui/material';
import SwitchInput from '@/components/forms/SwitchInput';
import SelectInput from '@/components/forms/SelectInput';
import { MediaLicense } from '@/declarations/models/MediaLicense';
import TextInput from '@/components/forms/TextInput';
import React from 'react';
import { DMFilterSearchBlockModel } from '@/declarations/models/blocks/DMBlock';

interface LicenseTypesProps {
  blockPath: string;
  currentBlock: DMFilterSearchBlockModel;
  tCommon: (key: string) => string;
  tComponents: (key: string) => string;
  filterEnabled: boolean;
}

const FilterLicenseTypes: React.FC<LicenseTypesProps> = ({
  blockPath,
  currentBlock,
  tComponents,
  tCommon,
  filterEnabled,
}) => (
  <Container gap={0} fullWidth column right>
    <Container fullWidth>
      <Container fullWidth left>
        <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
          {tComponents('DMFilterSearch.LicenseTypesTitleLabel')}
        </Typography>
      </Container>
      <Container fullWidth right>
        <div style={{ width: 'auto' }}>
          <SwitchInput
            path={`${blockPath}.userCanFilterLicenseTypes`}
            label={tComponents('DMFilterSearch.UserFiltrationOnWebsite')}
          />
        </div>
      </Container>
    </Container>
    <Container fullWidth>
      <SelectInput
        options={Object.values(MediaLicense).filter((l) => !!l)}
        getOptionKey={(o) => o}
        getOptionLabel={(o) => tCommon(`MediaLicense.Label.${o}`)}
        path={`${blockPath}.licenseTypes`}
        renderValue={(v) => (typeof v === 'string' ? v : v.join(','))}
        label={tComponents('DMFilterSearch.LicenseTypesLabel')}
        size='small'
        multiSelect
        initialMultiSelectValue={currentBlock?.licenseTypes}
      />
      {filterEnabled && (
        <div style={{ width: '30%' }}>
          <TextInput
            path={`${blockPath}.licenseTypesDropDownMenuTitle`}
            label={tComponents('DMFilterSearch.LicenseTypesDropDownMenuTitleLabel')}
          />
        </div>
      )}
    </Container>
  </Container>
);

export default FilterLicenseTypes;
